import { Dialog, DialogContent, DialogActions, DialogTitle, Button, Grid, Box, Divider } from '@mui/material';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { myApi } from '../../../config/axiosConfig';
import Swal from 'sweetalert2';

import MyTextArea from '../../../components/inputs/MyTextArea';
import MyTextInput from '../../../components/inputs/MyTextInput';
import MyAutoComplete from '../../../components/inputs/MyAutoComplete';
import MyDateTimeInput from '../../../components/inputs/MyDateTimeInput';

const CrearIncidencia = ({ open, onClose }) => {

    const shifts = [

        { label: 'Manana', value: 'Manana' },
        { label: 'Tarde', value: 'Tarde' },
        { label: 'Noche', value: 'Noche' },

    ];

    const tiposSiniestros = [

        { label: 'Accidente', value: 'Accidente' },
        { label: 'Asalto', value: 'Asalto' },
        { label: 'Falla Sospechosa', value: 'Falla Sospechosa' },
        { label: 'Intento Robo', value: 'Intento Robo' },
        { label: 'Otro', value: 'Otro' },
        { label: 'Robo Parcial', value: 'Robo Parcial' },
        { label: 'Robo Total', value: 'Robo Total' },
        
    ];

    const catReporto = [

        { label: 'Si', value: 1 },
        { label: 'No', value: 0 },

    ]

    const statusCaja = [

        { label: 'Abierta', value: 'Abierta' },
        { label: 'Cerrada', value: 'Cerrada' },
        { label: 'Desaparecida', value: 'Desaparecida' },
        { label: 'N/A', value: 'N/A' },

    ]

    const handleSubmit = async (values) => {

        console.log(values);

    };

    return (

        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
        >

            <Formik
                initialValues={{
                    monitor_name: '',
                    shift: '',
                    incident_date: '',
                    unit_number: '',
                    trailer_number: '',
                    driver_name: '',
                    driver_phone: '',
                    company_name: '',
                    incident_type: '',
                    event_description: '',
                    location: '',
                    city_state: '',
                    latitude: '',
                    longitude: '',
                    operator_reported: '',
                    unit_status: '',
                    trailer_status: '',
                    insurance_report_number: '',
                    evidence_available: '',
                    contacted_authority_name: '',
                    external_report_number: '',
                    engine_shutdown: '',
                    escalated_to: '',
                    escalation_time: '',    
                    additional_notes: ''
                }}
                onSubmit={async (values, { setSubmitting, resetForm }) => {

                    handleSubmit(values);

                }}
            >

                {({ handleSubmit, values }) => (

                <Form>

                {/* HEADER */}
                <DialogTitle>
                    Crear Incidencia
                </DialogTitle>

                {/* BODY */}
                <DialogContent
                >

                    <Grid 
                        container 
                        spacing={2} 
                        marginTop={1} 
                        // sx={{ 
                        //     maxHeight: '80vh', 
                        //     overflow: 'auto',
                        //     pt: 2,
                        // }}
                    >

                        {/* TURNO */}
                        <Grid size={4}>

                            <MyAutoComplete
                                name="shift"
                                label="Turno" 
                                options={shifts} 
                            />

                        </Grid>

                        {/* FECHA INCIDENCIA */}
                        <Grid size={4}>

                            <MyDateTimeInput
                                name="incident_date"
                                label="Fecha de Incidencia" 
                            />

                        </Grid>

                        {/* UNIDAD */}
                        <Grid size={4}>

                            <MyTextInput
                                name="unit_number"
                                label="Unidad" 
                            />

                        </Grid>

                        {/* TRAILER */}
                        <Grid size={4}>

                            <MyTextInput
                                name="trailer_number"
                                label="Trailer" 
                            />

                        </Grid>

                        {/* DRIVER */}
                        <Grid size={4}>

                            <MyTextInput
                                name="driver_name"
                                label="Chofer" 
                            />

                        </Grid>

                        {/* DRIVER PHONE */}
                        <Grid size={4}>

                            <MyTextInput
                                name="driver_phone"
                                label="Telefono Chofer" 
                            />

                        </Grid>

                        {/* COMPANY */}
                        <Grid size={4}>

                            <MyTextInput
                                name="company_name"
                                label="Empresa" 
                            />

                        </Grid>

                        {/* TIPO SINIESTRO */}
                        <Grid size={4}>

                            <MyAutoComplete
                                name="incident_type"
                                label="Tipo Siniestro" 
                                options={tiposSiniestros}
                            />

                        </Grid>

                        {/* COMPANY */}
                        <Grid size={12}>

                            <MyTextArea
                                name="event_description"
                                label="Descripcion Evento"
                            />

                        </Grid>

                        {/* UBICACION */}
                        <Grid size={4}>

                            <MyTextInput
                                name="location"
                                label="Ubicacion" 
                            />

                        </Grid>

                        {/* CIUDAD */}
                        <Grid size={4}>

                            <MyTextInput
                                name="city_state"
                                label="Ciudad / Estado" 
                            />

                        </Grid>

                        {/* COORDENADAS */}
                        <Grid size={4}>

                            <MyTextInput
                                name="latitude"
                                label="Latitud" 
                            />

                        </Grid>

                        {/* COORDENADAS */}
                        <Grid size={4}>

                            <MyTextInput
                                name="longitude"
                                label="Longitud" 
                            />

                        </Grid>

                        {/* REPORTO */}
                        <Grid size={4}>

                            <MyAutoComplete
                                name="operator_reported"
                                label="Reporto Operador ?" 
                                options={catReporto}
                            />

                        </Grid>

                        {/* STATUS UNIDAD */}
                        <Grid size={4}>

                            <MyTextInput
                                name="unit_status"
                                label="Status Unidad" 
                            />

                        </Grid>

                        {/* STATUS CAJA */}
                        <Grid size={4}>

                            <MyAutoComplete
                                name="trailer_status"
                                label="Status Trailer" 
                                options={statusCaja}
                            />

                        </Grid>

                        {/* NUM REPORTE ASEGURADOR */}
                        <Grid size={4}>

                            <MyTextInput
                                name="insurance_report_number"
                                label="Num. Reporte Aseguradora" 
                            />

                        </Grid>

                        {/* EVIDENCIA DISPONIBLE */}
                        <Grid size={4}>

                            <MyAutoComplete
                                name="evidence_available"
                                label="Evidencia Disponible"
                                options={catReporto} 
                            />

                        </Grid>

                        {/* AUTORIDAD CONTACTADA */}
                        <Grid size={4}>

                            <MyTextInput
                                name="contacted_authority_name"
                                label="Autoridad Contactada"
                            />

                        </Grid>

                        {/* REPORTE EXTERNO */}
                        <Grid size={4}>

                            <MyTextInput
                                name="external_report_number"
                                label="Num. Reporte Externo"
                            />

                        </Grid>

                        {/* PARO DE MOTOR ? */}
                        <Grid size={4}>

                            <MyAutoComplete
                                name="engine_shutdown"
                                label="Paro De Motor ?"
                                options={catReporto} 
                            />

                        </Grid>

                        {/* ESCALADO A */}
                        <Grid size={4}>

                            <MyTextInput
                                name="escalated_to"
                                label="Escalado a"
                            />

                        </Grid>

                        {/* FECHA ESCALADO */}
                        <Grid size={4}>

                            <MyDateTimeInput
                                name="escalation_time"
                                label="Fecha Escalado"
                            />

                        </Grid>

                        {/* FECHA ESCALADO */}
                        <Grid size={12}>

                            <MyTextArea
                                name="additional_notes"
                                label="Comentarios Adicionales"
                            />

                        </Grid>

                    </Grid>

                </DialogContent>

                {/* FOOTER */}
                <DialogActions
                    sx={{ 
                        justifyContent: 'space-between',
                        p: 2 
                    }}
                >

                    <Button 
                        onClick={onClose}
                        variant="contained"
                    >
                        Cancelar
                    </Button>

                    <Button 
                        variant="contained"
                        color="success"
                        onClick={handleSubmit}
                    >
                        Guardar
                    </Button>

                </DialogActions>

                </Form>

                )}

            </Formik>

        </Dialog>

    )
    
}

export default CrearIncidencia